const EXPIRY_BUFFER_SECONDS = 60;

/** Decode a JWT's `exp` claim (seconds since epoch), or null if absent/unparseable. */
function getJwtExpSeconds(token: string): number | null {
  try {
    const parts = token.split('.');
    if (parts.length !== 3) return null;

    const base64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    const payload = JSON.parse(atob(base64));
    return typeof payload.exp === 'number' ? payload.exp : null;
  } catch {
    return null;
  }
}

export function isJwtExpired(token: string): boolean {
  const exp = getJwtExpSeconds(token);
  if (exp === null) return true;

  const nowInSeconds = Math.floor(Date.now() / 1000);
  return nowInSeconds >= exp - EXPIRY_BUFFER_SECONDS;
}

/** Milliseconds until the JWT expires (may be negative if already expired), or null for opaque/exp-less tokens. */
export function msUntilJwtExpiry(token: string): number | null {
  const exp = getJwtExpSeconds(token);
  return exp === null ? null : exp * 1000 - Date.now();
}
